import { AUTH_ROUTES } from "../constants/auth.js";

/**
 * Invite emails and the admin "Copy Signup URL" button use a path link
 * (/invite-signup?token=...), but the router runs in hash mode and only reads
 * what follows "#". Move the path and query into the hash so the invite page
 * renders instead of the root Login route. Must run before the router is created.
 */
export const normalizeInviteUrl = () => {
  if (typeof window === "undefined") return;

  const { pathname, search, hash } = window.location;
  const path = pathname.replace(/\/+$/, "");

  if (path !== AUTH_ROUTES.INVITE_SIGNUP || hash) return;

  window.history.replaceState(
    window.history.state,
    "",
    `/#${AUTH_ROUTES.INVITE_SIGNUP}${search}`
  );
};

normalizeInviteUrl();
